import R from 'app/assets/R'
import { FunctionPermissionEnum } from 'app/common/permission-module'
import { IGroupReport } from 'app/components/common/BaseLayoutReport/type'
import {
  CUSTOMER_SURVEY_REPORT_PATH,
  REPORT_001_FULL_PATH,
  REPORT_002_FULL_PATH,
  REPORT_003_FULL_PATH,
  REPORT_004_FULL_PATH,
  REPORT_005_FULL_PATH,
  REPORT_006_FULL_PATH,
  REPORT_007_FULL_PATH,
  REPORT_008_FULL_PATH,
  REPORT_009_FULL_PATH,
  REPORT_010_FULL_PATH,
  REPORT_011_FULL_PATH,
  REPORT_012_FULL_PATH,
  REPORT_014_FULL_PATH,
  REPORT_015_FULL_PATH,
  REPORT_016_FULL_PATH,
  REPORT_018_FULL_PATH,
  REPORT_020_FULL_PATH,
  REPORT_023_FULL_PATH,
  REPORT_021_FULL_PATH,
  REPORT_024_FULL_PATH,
  REPORT_REFERER_FULL_PATH,
} from 'app/components/router/route-path'
import { DateUtil } from 'parkway-web-common'

export const data: IGroupReport[] = [
  {
    id: 1,
    titleI18nKey: R.strings.report_group_marketing,
    pages:[
      {
        id: 11,
        indexReport: '001',
        labelI18nKey: R.strings.report_001_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_001_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_1,
      },
      {
        id: 12,
        indexReport: '006',
        labelI18nKey: R.strings.report_006_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_006_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_6,
      },
      {
        id: 13,
        indexReport: '007',
        labelI18nKey: R.strings.report_007_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_007_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_7,
      },
      {
        id: 14,
        indexReport: '008',
        labelI18nKey: R.strings.report_008_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_008_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_8,
      },
      {
        id: 15,
        indexReport: '009',
        labelI18nKey: R.strings.report_009_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_009_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_9,
      },
      {
        id: 16,
        indexReport: '010',
        labelI18nKey: R.strings.report_010_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_010_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_10,
      },
      {
        id: 17,
        indexReport: '011',
        labelI18nKey: R.strings.report_011_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_011_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_11,
      },
      {
        id: 18,
        indexReport: '017',
        labelI18nKey: R.strings.referer_report,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_REFERER_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_17,
      },
      {
        id: 45,
        indexReport: '021',
        labelI18nKey: R.strings.report_21,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_021_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_21,
      },
      {
        id: 19,
        indexReport: '023',
        labelI18nKey: R.strings.report_23_title,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_023_FULL_PATH,
        permissions: [
          FunctionPermissionEnum.REPORT_READ_REPORT_23,
          FunctionPermissionEnum.REPORT_READ_REPORT_23_YOU_MANAGEMENT,
        ],
      },
    ],
  },
  {
    id: 2,
    titleI18nKey: R.strings.report_group_customer_care,
    pages:[
      {
        id: 21,
        indexReport: '002',
        labelI18nKey: R.strings.report_002_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_002_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_2,
      },
      {
        id: 22,
        indexReport: '003',
        labelI18nKey: R.strings.report_003_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_003_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_3,
      },
      {
        id: 23,
        indexReport: '013',
        labelI18nKey: R.strings.survey_report,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: CUSTOMER_SURVEY_REPORT_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_4,
      },
    ],
  },
  {
    id: 3,
    titleI18nKey: R.strings.report_group_operation,
    pages:[
      {
        id: 31,
        indexReport: '004',
        labelI18nKey: R.strings.report_004_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_004_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_4,
      },
      {
        id: 32,
        indexReport: '005',
        labelI18nKey: R.strings.report_005_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_005_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_5,
      },
      {
        id: 33,
        indexReport: '014',
        labelI18nKey: R.strings.report_14_content_title,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_014_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_14,
      },
      {
        id: 34,
        indexReport: '015',
        labelI18nKey: R.strings.report_15,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_015_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_15,
      },
      {
        id: 35,
        indexReport: '016',
        labelI18nKey: R.strings.report_16,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_016_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_16,
      },
      {
        id: 44,
        indexReport: '020',
        labelI18nKey: R.strings.report_20,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_020_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_20,
      },
    ],
  },
  {
    id: 4,
    titleI18nKey: R.strings.report_group_accounting,
    pages:[
      {
        id: 41,
        indexReport: '012',
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        labelI18nKey: R.strings.report_012_description,
        path: REPORT_012_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_12,
      },
      {
        id: 42,
        indexReport: '018',
        labelI18nKey: R.strings.report_18_description,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_018_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_18,
      },
      {
        id: 45,
        indexReport: '024',
        labelI18nKey: R.strings.report_24,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: REPORT_024_FULL_PATH,
        permission: FunctionPermissionEnum.REPORT_READ_REPORT_24,
      },
    ],
  },
]
